@if (servicio.disponible()) {
  <div class="campana">
    <button
      type="button"
      class="campana__boton"
      [class.campana__boton--con-avisos]="servicio.total() > 0"
      [attr.aria-label]="t().campana.titulo"
      [attr.aria-expanded]="abierta()"
      aria-haspopup="dialog"
      (click)="alternar()"
    >
      <i class="pi pi-bell" aria-hidden="true"></i>
      @if (servicio.total() > 0) {
        <span class="campana__contador">{{ servicio.total() > 99 ? '99+' : servicio.total() }}</span>
      }
    </button>

    @if (abierta()) {
      <div class="campana__panel" role="dialog" [attr.aria-label]="t().campana.titulo">
        <div class="campana__cabecera">{{ t().campana.titulo }}</div>
        @if (servicio.puedeRevisarPagos() && servicio.pagosPendientes() > 0) {
          <button type="button" class="campana__aviso campana__aviso--nuevo" (click)="irAPagosPendientes()">
            <span class="campana__aviso-titulo">
              <i class="pi pi-wallet" aria-hidden="true"></i>
              {{ servicio.pagosPendientes() }} {{ servicio.pagosPendientes() === 1 ? t().campana.pagoPendiente : t().campana.pagosPendientes }}
            </span>
            <span class="campana__aviso-cuerpo">{{ t().campana.irARevisar }}</span>
          </button>
        }
        @for (aviso of servicio.avisos().slice(0, maximo); track aviso.id) {
          <button type="button" class="campana__aviso" [class.campana__aviso--nuevo]="!aviso.readAt" (click)="leer(aviso)">
            <span class="campana__aviso-titulo">{{ aviso.title }}</span>
            <span class="campana__aviso-cuerpo">{{ aviso.body }}</span>
            <span class="campana__aviso-fecha">{{ fecha(aviso) }}</span>
          </button>
        } @empty {
          @if (!(servicio.puedeRevisarPagos() && servicio.pagosPendientes() > 0)) {
            <p class="campana__vacio">{{ t().campana.vacio }}</p>
          }
        }
      </div>
    }
  </div>
}
